import Vue from "vue";
import Router from "vue-router";

import { getToken } from "@/utils/token";

import Login from "@/views/Login.vue";
import Layout from "@/views/Layout.vue";
import User from "@/views/User.vue";
import Org from "@/views/Org.vue";
import Cabinet from "@/views/Cabinet.vue";
import Log from "@/views/Log.vue";
import OpenLog from "@/views/OpenLog.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/login", component: Login },
    {
      path: "/",
      component: Layout,
      children: [
        { path: "", redirect: "/cabinet" },
        { path: "cabinet", component: Cabinet },
        { path: "org", component: Org },
        { path: "user", component: User },
        { path: "log", component: Log },
        { path: "open-log", component: OpenLog }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === "/login") return next();
  if (!getToken()) return next("/login");
  next();
});

export default router;

